export default "__VITE_ASSET__DylSYQH6__"